import { ReferentialDto, ReferentialKey } from "api/referential";
import { TenantDto } from "api/tenant";
import { TenantFormFieldNames } from "../types/tenantFormFieldNames";
import { TenantFormValues } from "../types/tenantFormValues";
import { toDayInput } from "core/utils/dates";

/**
 * Convertit un TenantDto vers un TenantFormValues
 * @param dto - Le DTO tenant
 * @param civilityLabel - Le libellé de civilité (si vous voulez afficher le libellé dans le form)
 * @param employmentStatusLabel - Le libellé du statut d'emploi (si vous voulez afficher le libellé dans le form)
 * @returns TenantFormValues
 */
export const mapTenant = (
  dto: TenantDto,
  referentialsData: Record<ReferentialKey, ReferentialDto[]>
): TenantFormValues => {

  const getReferentialCode = (referentialKey: ReferentialKey, id?: string | null) => {
    const referential = referentialsData[referentialKey].find((item: any) => item.id === id);
    return referential ? (referential.code as string) : undefined;
  };

  return {
    id: dto.id,
    [TenantFormFieldNames.LastName]: dto.lastName,
    [TenantFormFieldNames.FirstName]: dto.firstName,
    [TenantFormFieldNames.BirthDate]: toDayInput(dto.birthDate),
    [TenantFormFieldNames.Phone]: dto.phone,
    [TenantFormFieldNames.Email]: dto.email,
    [TenantFormFieldNames.Civility]: getReferentialCode(ReferentialKey.Civility, dto.civilityId) || '',
    [TenantFormFieldNames.Guarantor]: dto.guarantor,
    [TenantFormFieldNames.ProfessionalSituation]: getReferentialCode(ReferentialKey.EmploymentStatus, dto.employmentStatusId) || '',
    [TenantFormFieldNames.CheckInDate]: toDayInput(dto.checkInDate),
    [TenantFormFieldNames.CheckOutDate]: dto.checkOutDate ? toDayInput(dto.checkOutDate) : undefined,
    [TenantFormFieldNames.RentPaymentsUpToDate]: dto.rentPaymentsUpToDate ?? undefined,
    [TenantFormFieldNames.Incomes]: dto.incomes.map(income => ({
      incomeType: getReferentialCode(ReferentialKey.IncomeType, income.incomeTypeId) || '',
      amount: income.value || 0,
    }))
  };
};
